import { render } from "./marital_information.html?vue&type=template&id=6061b2d8&external"
import script from "./marital_information.js?vue&type=script&lang=js&external"
export * from "./marital_information.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__